import { KeyboardEvent, MouseEvent as ReactMouseEvent, MouseEventHandler, SyntheticEvent } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { MouseButton, SerializableKeyEvent, SerializableMouseEvent } from "@multiweb/types/react";
import { Key } from "./constants";

const { stopPropagation } = bridge;

/**
 * Zastaví další propagování události.
 * @param event
 */
export const stopPropagationHandler = (event: SyntheticEvent) => stopPropagation(event);

/**
 * Převede událost kliknutí myši na serializovatelný objekt.
 * @param event Událost pro převedení.
 */
export const toSerializableMouseEvent = (event: ReactMouseEvent): SerializableMouseEvent => ({
    altKey: event.altKey,
    ctrlKey: event.ctrlKey,
    metaKey: event.metaKey,
    shiftKey: event.shiftKey,
    button: event.button,
});

/**
 * Převede událost stisku klávesy na serializovatelný objekt.
 * @param event Událost pro převedení.
 */
export const toSerializableKeyEvent = (event: KeyboardEvent): SerializableKeyEvent => ({
    altKey: event.altKey,
    ctrlKey: event.ctrlKey,
    metaKey: event.metaKey,
    shiftKey: event.shiftKey,
    key: event.key,
    keyCode: event.keyCode,
});

/**
 * Zjistí, zda se jedná o událost hlavního tlačítka myši.
 * @param event
 */
export const isLeftButtonEvent = (event: ReactMouseEvent) => event.button === MouseButton.leftButton;

/**
 * Zjistí, zda se jedná o aktivační událost myši.
 * @param event
 */
export const isActivatingKeyEvent = (event: KeyboardEvent) => event.key === Key.Enter || event.key === Key.Space;

/**
 * Vytvoří obalující handler pro událost myši. Událost propaguje pokud se jedná o kliknutí levým tlačítkem myši.
 * @param mouseHandler Handler, který je obalen.
 */
export const createLeftClickHandler = (mouseHandler: MouseEventHandler) => (event: ReactMouseEvent) => {
    if (isLeftButtonEvent(event)) {
        mouseHandler(event);
    }
};
